import { VisitHistoryHeader } from 'components/TreatmentPlan';
import Item from './Item'

const VisitHistory = ({ treatmentPlanProgresses }) => {
  if (!treatmentPlanProgresses)
    return (
      <div className="mt-6 px-6 pt-6 border-t border-slate-100">
        <VisitHistoryHeader />
        <div className="skeleton h-16 w-full mt-4"></div>
      </div>
    )

  return (
    <div className="mt-6 px-6 pt-6 border-t border-slate-100">
      <VisitHistoryHeader />

      {treatmentPlanProgresses.map((item, index) =>
        <Item
          key={`visit-history-${index}`}
          item={item}
        />
      )}
    </div>
  )
}

export default VisitHistory
